import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { groupSlotsByStartTime } from '../helpers';
import { getGroupsConfig } from '../../date-filters';
import { selectableItem } from '~/components/selectable-item';
import { TimeSlotSectionTitle } from './time-slot-section-title';
import { TimeSlotSectionContent } from './time-slot-section-content';

import styles from './TimeSlotSections.scss';

const SelectableTimeSlotSectionTitle = selectableItem(TimeSlotSectionTitle);

export class TimeSlotsSections extends PureComponent {
  state = {
    formattedSlots: [],
    displayedSectionName: '',
  };

  static getDerivedStateFromProps(
    { slots, selectedTimeSlot },
    { formattedSlots: prevFormattedSlots },
  ) {
    const formattedSlots = groupSlotsByStartTime(slots, getGroupsConfig());
    const areSlotsEqual = JSON.stringify(prevFormattedSlots) === JSON.stringify(formattedSlots);

    if (!areSlotsEqual) {
      const sectionWithSelectedSlot = Object.entries(formattedSlots).find(([, sectionSlots]) =>
        sectionSlots.some((slot) => slot.from === selectedTimeSlot.from),
      );
      const displayedSectionName =
        sectionWithSelectedSlot ||
        Object.entries(formattedSlots).find(([, sectionSlots]) => sectionSlots.length);
      if (displayedSectionName) {
        const [sectionName] = displayedSectionName;
        return {
          displayedSectionName: sectionName,
          formattedSlots,
        };
      }
    }

    return null;
  }

  onSectionChangeHandler = (section) => {
    this.setState(() => ({
      displayedSectionName: section ? section.id : '',
    }));
  };

  render() {
    const { selectedTimeSlot, selectTimeSlot } = this.props;
    const { formattedSlots, displayedSectionName } = this.state;

    return (
      <Fragment>
        <ul className={styles.TimeSlotSection__sections_list} data-testid="TimeSlotsSections">
          {Object.entries(formattedSlots).map(([sectionName, sectionSlots]) => (
            <li
              key={sectionName}
              className={[
                sectionName === displayedSectionName ? styles.TimeSlotSection_selected : '',
              ].join(' ')}
            >
              <SelectableTimeSlotSectionTitle
                isChecked={sectionName === displayedSectionName}
                isDisabled={!sectionSlots.length}
                type="radio"
                key={sectionName}
                section={{ id: sectionName }}
                propName="section"
                onChange={this.onSectionChangeHandler}
              />
            </li>
          ))}
        </ul>
        <TimeSlotSectionContent
          slots={formattedSlots}
          displayedSectionName={displayedSectionName}
          selectedTimeSlot={selectedTimeSlot}
          selectTimeSlot={selectTimeSlot}
        />
      </Fragment>
    );
  }
}

TimeSlotsSections.propTypes = {
  slots: PropTypes.array,
  selectTimeSlot: PropTypes.func.isRequired,
  selectedTimeSlot: PropTypes.shape({
    from: PropTypes.number.isRequired,
    to: PropTypes.number,
  }).isRequired,
};
